import calendarGridComponent from './calendarGrid.component';

let calendarGridModule = angular.module('vacations-absences.calendarGrid', [])

.component('calendarGrid', calendarGridComponent)

.name;

export default calendarGridModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarGrid/calendarGrid.js